<script setup>
import { computed } from 'vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt, contentAttributes } = useMessageContext();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);

const isToolLog = computed(
  () => contentAttributes.value?.toolLog || contentAttributes.value?.tool_log
);
</script>

<template>
  <BaseBubble
    v-if="isToolLog"
    v-tooltip.top="readableTime"
    class="px-3 py-1.5 !rounded-lg flex min-w-0 items-center gap-2 !bg-n-slate-3 border border-n-slate-5 !text-n-slate-11 text-xs font-mono"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
  <BaseBubble
    v-else
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
